import { apiClient } from "@/core/api/httpClient";

export default {
  namespaced: true,
  actions: {
    getByOrg: ({ commit }, id) => {
      return apiClient.get(`/insight-models/${id}`).then(({data}) => data);
    },
  },
};
